/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_NewInputs */

const cs_pipelines_new = /** @type {(inputs: Pipelines_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová pipeline`)
};

const en_pipelines_new = /** @type {(inputs: Pipelines_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New pipeline`)
};

/**
* | output |
* | --- |
* | "New pipeline" |
*
* @param {Pipelines_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_new = /** @type {((inputs?: Pipelines_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_new(inputs)
	return cs_pipelines_new(inputs)
});